 
document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {
    if (!location.href.includes('/collections')) return;

    // ---------- CONFIG (sirf yahi edit karo) ----------
    const GLOBAL_TAGS_REMOVE = [
      "Clearance","Mens","Womens","Unisex","UploadB","Kids","Sweat Shirts","Jackets & Parkas","SUN"
    ];

    const COLLECTION_TAGS_REMOVE = [
      { match: ['/collections/apparel'], ns: 'apparel',
        tags: ["Mens","Kids","Womens","Accessories","Gloves"] },

      { match: ['/collections/mens-bottoms'], ns: 'mensbottoms',
        tags: ["Fishing & Outdoor Clothing","Rain","Snow","Accessories","Gloves"] },

      { match: ['/collections/mens'], ns: 'mens',
        tags: ["Fishing and Outdoor Clothing","Belts & Suspenders","Bibs & Pants","Sweatshirts"] },

      { match: ['/collections/snow'], ns: 'snow', tags: ["Mens","Womens","Kids"] },

      { match: ['/collections/backpacking-camping'], ns: 'backpackingCamping', tags: ["Mens","Backpacking & Camping","Camping","Womens","Womens","Womens","Kids"] },

      {
        match: ['/collections/fishing'],
        ns: 'fishing',
        tags: ["Mens","Hunting Knives","Gun Maintenance","Hunting Clothing","Hunting Accessories","Clothing","Fishing","Fishing FMS"]
      },

      { match: ['/collections/womens-apparel'], ns: 'womensApparel', tags: ["Mens","Womens"] },

            { match: ['/collections/womens-jackets'], ns: 'womensJackets', tags: ["Casual Jackets"] },


      { match: ['/collections/water-sports'], ns: 'watersports', tags: ["Repair"] },
      { match: ['/collections/backpacking-camping'], ns: 'backpackingcamping', tags: ["Camp Tools", "OMCV"] },

      { match: ['/collections/climbing'], ns: 'climbing', tags: ["Chalk Bags","Slings", "Webbing", "Ropes"] },
      { match: ['/collections/fishing'], ns: 'fishing', tags: ["Chalk Bags","Slings", "Footwear" ,"Hooks" ,"Fly Fishing" , "Webbing", "Ropes"] },

      { match: ['/collections/snowsports-equipment-or-snowsports-gear'], ns: 'snowsports', tags: ["Skate Ski","Wax","Ski Boot Bag", "General Accessories"] },

      // { match: ['/collections/mens-jackets'], ns: 'mensJackets', tags: ["Synthetic"] },
    ];

    const JACKET_COLLECTIONS = [
      '/collections/mens-jackets',
      '/collections/mens-insulated-synthetic-jackets',
      '/collections/mens-insulated-down-jackets',
      '/collections/mens-hardshell-jackets-1',
      '/collections/mens-softshell-jackets',
      '/collections/mens-fleece-jackets',
      '/collections/mens-snowsports-jackets',
      '/collections/mens-casual-jackets',
      '/collections/womens-jackets',
      '/collections/womens-insulated-synthetic-jackets',
      '/collections/womens-insulated-down-jackets',
      '/collections/womens-hardshell-jackets-1',
      '/collections/womens-softshell-jackets',
      '/collections/womens-fleece-jackets',
      '/collections/womens-snowsports-jackets',
      '/collections/womens-casual-jackets'
    ];

    const JACKET_TAGS_REMOVE = ["Jackets","Sandals","Footwear","Clearance"];

    // ---------- HELPERS ----------
    const bind = (ns, fn) => {
      fn(); // run once immediately
      $(document)
        .off(`Searchanise.ResultsUpdated.${ns}`)
        .on(`Searchanise.ResultsUpdated.${ns}`, fn);
    };

    const removeFromTagsBlock = (tags) => {
      if (!tags || !tags.length) return;

      const selectors = tags.map(
        v => `#snize_filters_block_tags li:has(.snize-product-filters-checkbox[value="${v}"])`
      ).join(', ');

      $(selectors).remove();
    };

    const matchesAny = (paths) => paths.some(p => location.href.includes(p));

    // ---------- 1) Global tags removal ----------
    if (GLOBAL_TAGS_REMOVE.length) {
      bind('globalTags', () => removeFromTagsBlock(GLOBAL_TAGS_REMOVE));
    }

    // ---------- 2) Jackets group ----------
    if (matchesAny(JACKET_COLLECTIONS)) {
      bind('jacketsGroup', () => removeFromTagsBlock(JACKET_TAGS_REMOVE));
    }

    // ---------- 3) Per-collection ----------
    COLLECTION_TAGS_REMOVE.forEach(rule => {
      if (!matchesAny(rule.match)) return;
      bind(rule.ns, () => removeFromTagsBlock(rule.tags || []));
    });

  })(window.Searchanise && window.Searchanise.$ ? window.Searchanise.$ : window.jQuery);
});
 
